export const PatientIdFormatter =
  (hospitalId, groupId = 1) =>
  patient =>
    (hospitalId ? `G${groupId}H${hospitalId}-` : '#') + patient.id;
